<template>
  <v-container fluid>
    <v-text-field
      label="Navn"
      v-model="customerData.customer.label"
      disabled
    ></v-text-field>
    <v-tabs>
      <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.users }}</v-tab>
      <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.fagressurser }}</v-tab>
      <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.categories }}</v-tab>
      <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.org_sectors }}</v-tab>
      <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.org_areas }}</v-tab>
      <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.org_departments }}</v-tab>
      <v-tab ripple>{{ GET_ORDLYD && GET_ORDLYD.main_ordlyd }}</v-tab>
      <v-tab ripple>Plan</v-tab>

      <!-- Users -->
      <v-tab-item>       
<!-- 
        <v-text-field
          v-model="search"
          placeholder="Søk på Navn / Brukernavn her"
          hide-details
          prepend-icon="sentiment_very_satisfied" 
        ></v-text-field> -->
        <v-data-table
          :headers="UserHeaders"
          :items="customerData.users"
          disable-initial-sort
          hide-actions
          :search="search"
        >
          <template v-slot:headers="props">
            <tr>
              <th>
                <v-text-field
                  v-model="search"
                  placeholder="Søk på Navn / Brukernavn her"
                ></v-text-field>
              </th>
            </tr>
            <tr>
              <th
                class="text-xs-left"
                v-for="header in props.headers"
                :key="header.text"
              >
                {{ header.text }}
              </th>
              <th class="text-xs-right">
                <v-btn flat @click="dialogAlterUser = !dialogAlterUser"
                  >legg til {{ GET_ORDLYD && GET_ORDLYD.user }}</v-btn
                >
              </th>
            </tr> 
            </template>
          <template v-slot:items="props">
            <tr>
              <!-- <td>{{ props.item.id }}</td> -->
              <td>{{ props.item.name }} </td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.orgLabel }}</td>
              <td>
                {{ userRoles.find((el) => el.value == props.item.role).text }}
              </td>
              <td align="right">
                <v-icon @click="editUser(props.item.id)">edit</v-icon>
                <v-icon @click="deleteUser(props.item.id)">delete</v-icon>
              </td>
            </tr>
          </template>

          <template v-slot:footer></template>
        </v-data-table>
      </v-tab-item>
      <!-- Ressurser -->
      <v-tab-item>
        <v-data-table :items="customerData.resources" hide-actions>
          <template v-slot:headers>
            <tr>
              <th align="left">
                {{ GET_ORDLYD && GET_ORDLYD.fagressurser_kode.toUpperCase() }}
              </th>
              <th align="left">
                {{
                  GET_ORDLYD && GET_ORDLYD.fagressurser_kontakt.toUpperCase()
                }}
              </th>
              <th align="left">
                {{ GET_ORDLYD && GET_ORDLYD.fagressurser_epost.toUpperCase() }}
              </th>
              <th align="left">
                {{
                  GET_ORDLYD &&
                    GET_ORDLYD.fagressurser_beskrivelse.toUpperCase()
                }}
              </th>
              <th align="left">
                {{
                  GET_ORDLYD && GET_ORDLYD.fagressurser_telefon.toUpperCase()
                }}
              </th>
              <th class="text-xs-right">
                <v-btn flat @click="dialogAlterResource = !dialogAlterResource"
                  >legg til {{ GET_ORDLYD && GET_ORDLYD.fagressurs }}</v-btn
                >
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <!-- <div>{{props.item}}</div> -->
            <tr>
              <td>{{ props.item.abbreviation }}</td>
              <td>{{ props.item.contact }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.phone }}</td>
              <td align="right">
                <v-icon @click="editResource(props.item.id)">edit</v-icon>
                <v-icon @click="deleteResource(props.item.id)">delete</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
      <!-- Categories -->
      <v-tab-item>
        <v-data-table :items="customerData.categories" hide-actions>
          <template v-slot:headers>
            <tr>
              <th align="left">
                {{ GET_ORDLYD && GET_ORDLYD.category.toUpperCase() }}
              </th>
              <th class="text-xs-right">
                <v-btn flat @click="dialogAlterCategory = !dialogAlterCategory"
                  >legg til {{ GET_ORDLYD && GET_ORDLYD.category }}</v-btn
                >
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <!-- <div>{{props.item}}</div> -->
            <tr>
              <td>{{ props.item.category }}</td>
              <td align="right">
                <v-icon @click="editCategory(props.item.id)">edit</v-icon>
                <v-icon @click="deleteCategory(props.item.id)">delete</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
      <!-- Sectors -->
      <v-tab-item>
        <v-data-table :items="customerData.sectors" hide-actions>
          <template v-slot:headers>
            <tr>
              <th align="left">{{ GET_ORDLYD && GET_ORDLYD.org_sector }}</th>
              <th style class="text-xs-right">
                <v-btn flat @click="dialogAlterSector = !dialogAlterSector"
                  >legg til {{ GET_ORDLYD && GET_ORDLYD.org_sector }}</v-btn
                >
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <!-- <div>{{props.item}}</div> -->
            <tr>
              <td>{{ props.item.label }}</td>
              <td align="right">
                <v-icon @click="editSector(props.item.id)">edit</v-icon>
                <v-icon @click="deleteSector(props.item.id)">delete</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
      <!-- Areas -->
      <v-tab-item>
        <v-data-table :items="customerData.areas" hide-actions>
          <template v-slot:headers>
            <tr>
              <th align="left">{{ GET_ORDLYD && GET_ORDLYD.org_sector }}</th>
              <th align="left">{{ GET_ORDLYD && GET_ORDLYD.org_area }}</th>
              <th style class="text-xs-right">
                <v-btn flat @click="dialogAlterArea = !dialogAlterArea"
                  >legg til {{ GET_ORDLYD && GET_ORDLYD.org_area }}</v-btn
                >
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <!-- <div>{{props.item}}</div> -->
            <tr>
              <td>{{ props.item.sector_label }}</td>
              <td>{{ props.item.label }}</td>
              <td align="right">
                <v-icon @click="editArea(props.item.id)">edit</v-icon>
                <v-icon @click="deleteArea(props.item.id)">delete</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
      <!-- Organisations / Departments -->
      <v-tab-item>
        <v-data-table
          :headers="OrgHeaders"
          :items="customerData.organisations"
          hide-actions
          disable-initial-sort
          :search="search"
        >
          <template v-slot:headers="props">
            <tr>
              <th>
                <v-text-field
                  v-model="search"
                  placeholder="Søk her"
                ></v-text-field>
              </th>
            </tr>
            <tr>
              <th
                class="text-xs-left"
                v-for="header in props.headers"
                :key="header.text"
              >
                {{ header.text }}
              </th>
              <th class="text-xs-right">
                <v-btn
                  flat
                  @click="dialogAlterDepartment = !dialogAlterDepartment"
                  >legg til {{ GET_ORDLYD && GET_ORDLYD.org_department }}</v-btn
                >
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.leader }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.sector_label }}</td>
              <td>{{ props.item.area_label }}</td>
              <td>{{ props.item.label }}</td>
              <td align="right">
                <v-icon @click="editDepartment(props.item.id)">edit</v-icon>
                <v-icon @click="deleteDepartment(props.item.id)">delete</v-icon>
              </td>
            </tr>
          </template>

          <template v-slot:footer></template>
        </v-data-table>
      </v-tab-item>
      <!-- Ordlyd -->
      <v-tab-item>
        <v-data-table
          :headers="OrdLydHeaders"
          :items="customerData.ordlyd"
          hide-actions
          disable-initial-sort
        >
          <template v-slot:headers="props">
            <tr>
              <th
                class="text-xs-left"
                v-for="header in props.headers"
                :key="header.text"
              >
                {{ header.text }}
              </th>
              <th></th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.label }}</td>
              <td align="right">
                <v-icon @click="editOrdLyd(props.item.ordlyd_customer_id)"
                  >edit</v-icon
                >
                <v-icon @click="deleteOrdLyd(props.item.ordlyd_customer_id)"
                  >delete</v-icon
                >
              </td>
            </tr>
          </template>

          <template v-slot:footer></template>
        </v-data-table>
      </v-tab-item>
      <!-- Plans -->
      <v-tab-item>
        <v-data-table
          :headers="PlanHeaders"
          :items="plans"
          hide-actions
          disable-initial-sort
        >
          <template v-slot:headers="props">
            <tr>
              <th
                class="text-xs-left"
                v-for="header in props.headers"
                :key="header.text"
              >
                {{ header.text }}
              </th>
              <th style class="text-xs-right">
                <v-btn flat @click="dialogAlterPlan = !dialogAlterPlan"
                  >legg til plan</v-btn
                >
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.year }}</td>
              <td>{{ props.item.title }}</td>
              <td align="right">
                <v-btn
                  v-show="props.item.active == 0"
                  @click="setActivePlan(props.item.id)"
                >
                  Sett som aktiv
                </v-btn>
                <v-btn
                  v-show="props.item.active == 0 && props.item.deleted == 0"
                  @click="deletePlan(props.item.id)"
                >
                  Slett plan
                </v-btn>

                <v-btn
                  v-show="props.item.active == 0 && props.item.deleted == 1"
                  @click="undeletePlan(props.item.id)"
                >
                  Åpne plan
                </v-btn>
              </td>
            </tr>
          </template>

          <template v-slot:footer></template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>

    <v-dialog v-model="dialogAlterDepartment" width="500">
      <v-card>
        <v-card-title>
          <span class="display-1 font-weight-bold" v-if="AlterDepartmentData.id"
            >Oppdater {{ GET_ORDLYD && GET_ORDLYD.org_department }}</span
          >
          <span class="display-1 font-weight-bold" v-else
            >Legg til ny {{ GET_ORDLYD && GET_ORDLYD.org_department }}</span
          >
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogAlterDepartment" flat>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex>
                <v-text-field
                  label="Navn"
                  v-model="AlterDepartmentData.label"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-select
                  :items="customerData.sectors"
                  :label="GET_ORDLYD && GET_ORDLYD.org_sector"
                  item-text="label"
                  item-value="id"
                  v-model="AlterDepartmentData.sector_id"
                >
                  <template v-slot:item="{ item, index }">
                    <span>{{ item.label }}</span>
                  </template>
                </v-select>
              </v-flex>

              <v-flex
                v-if="
                  AlterDepartmentData.sector_id && selectedSectorAreas.length
                "
              >
                <v-select
                  :items="selectedSectorAreas"
                  :label="GET_ORDLYD && GET_ORDLYD.org_area"
                  item-text="label"
                  item-value="id"
                  v-model="AlterDepartmentData.area_id"
                >
                  <template v-slot:item="{ item, index }">
                    <span>{{ item.label }}</span>
                  </template>
                </v-select>
              </v-flex>

              <v-flex>
                <v-text-field
                  label="Leder"
                  v-model="AlterDepartmentData.leader"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  label="E-Post"
                  v-model="AlterDepartmentData.email"
                ></v-text-field>
              </v-flex>
              <v-flex d-flex align-center justify-center>
                <v-btn
                  v-if="AlterDepartmentData.id"
                  @click="submitEditDepartment"
                  flat
                  >Oppdater {{ GET_ORDLYD && GET_ORDLYD.org_department }}</v-btn
                >
                <v-btn v-else @click="submitAddDepartment" flat
                  >Legg til ny
                  {{ GET_ORDLYD && GET_ORDLYD.org_department }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAlterUser" width="500">
      <v-card>
        <v-card-title>
          <span class="display-1 font-weight-bold" v-if="AlterUserData.id"
            >Oppdater {{ GET_ORDLYD && GET_ORDLYD.user }}</span
          >
          <span class="display-1 font-weight-bold" v-else
            >Legg til ny {{ GET_ORDLYD && GET_ORDLYD.user }}</span
          >
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogAlterUser" flat>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex>
                <v-text-field
                  label="Navn"
                  v-model="AlterUserData.name"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  label="E-Post/Brukernavn"
                  v-model="AlterUserData.email"
                ></v-text-field>
              </v-flex>
              <v-flex v-if="!AlterUserData.id">
                <v-text-field
                  :label="GET_ORDLYD && GET_ORDLYD.password"
                  v-model="AlterUserData.password"
                  :append-icon="showpassword ? 'visibility' : 'visibility_off'"
                  @click:append="showpassword = !showpassword"
                  :type="showpassword ? 'text' : 'password'"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-select
                  :label="GET_ORDLYD && GET_ORDLYD.main_role"
                  :items="userRoles"
                  v-model="AlterUserData.role"
                ></v-select>
              </v-flex>
              <v-flex v-if="AlterUserData.role == 'user'">
                <v-autocomplete
                  v-model="AlterUserData.organisation"
                  :items="customerData.organisations"
                  item-text="label"
                  item-value="id"
                  :label="GET_ORDLYD && GET_ORDLYD.org_department"
                ></v-autocomplete>
              </v-flex>
              <v-flex d-flex align-center justify-center>
                <v-btn v-if="AlterUserData.id" @click="submitEditUser" flat
                  >Oppdater {{ GET_ORDLYD && GET_ORDLYD.user }}</v-btn
                >
                <v-btn v-else @click="submitAddUser" flat
                  >Legg til ny {{ GET_ORDLYD && GET_ORDLYD.user }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAlterResource" width="500">
      <v-card>
        <v-card-title>
          <span class="display-1 font-weight-bold" v-if="AlterUserData.id"
            >Oppdater {{ GET_ORDLYD && GET_ORDLYD.fagressurs }}</span
          >
          <span class="display-1 font-weight-bold" v-else
            >Legg til ny {{ GET_ORDLYD && GET_ORDLYD.fagressurs }}</span
          >
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogAlterResource" flat>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex>
                <v-text-field
                  :label="GET_ORDLYD && GET_ORDLYD.fagressurser_kode"
                  v-model="AlterResourceData.abbreviation"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  :label="GET_ORDLYD && GET_ORDLYD.fagressurser_beskrivelse"
                  v-model="AlterResourceData.description"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  :label="GET_ORDLYD && GET_ORDLYD.fagressurser_kontakt"
                  v-model="AlterResourceData.contact"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  :label="GET_ORDLYD && GET_ORDLYD.fagressurser_epost"
                  v-model="AlterResourceData.email"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  :label="GET_ORDLYD && GET_ORDLYD.fagressurser_telefon"
                  v-model="AlterResourceData.phone"
                ></v-text-field>
              </v-flex>
              <v-flex d-flex align-center justify-center>
                <v-btn
                  v-if="AlterResourceData.id"
                  @click="submitEditResource"
                  flat
                  >Oppdater {{ GET_ORDLYD && GET_ORDLYD.fagressurs }}</v-btn
                >
                <v-btn v-else @click="submitAddResource" flat
                  >Legg til ny {{ GET_ORDLYD && GET_ORDLYD.fagressurs }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAlterCategory" width="500">
      <v-card>
        <v-card-title>
          <span class="display-1 font-weight-bold" v-if="AlterCategoryData.id"
            >Oppdater {{ GET_ORDLYD && GET_ORDLYD.category }}</span
          >
          <span class="display-1 font-weight-bold" v-else
            >Legg til ny {{ GET_ORDLYD && GET_ORDLYD.category }}</span
          >
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogAlterCategory" flat>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex>
                <v-text-field
                  :label="GET_ORDLYD && GET_ORDLYD.category"
                  v-model="AlterCategoryData.category"
                ></v-text-field>
              </v-flex>
              <v-flex d-flex align-center justify-center>
                <v-btn
                  v-if="AlterCategoryData.id"
                  @click="submitEditCategory"
                  flat
                  >Oppdater {{ GET_ORDLYD && GET_ORDLYD.category }}</v-btn
                >
                <v-btn v-else @click="submitAddCategory" flat
                  >Legg til ny {{ GET_ORDLYD && GET_ORDLYD.category }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAlterSector" width="500">
      <v-card>
        <v-card-title>
          <span class="display-1 font-weight-bold" v-if="AlterSectorData.id"
            >Oppdater {{ GET_ORDLYD && GET_ORDLYD.org_sector }}</span
          >
          <span class="display-1 font-weight-bold" v-else
            >Legg til ny {{ GET_ORDLYD && GET_ORDLYD.org_sector }}</span
          >
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogAlterSector" flat>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex>
                <v-text-field
                  :label="GET_ORDLYD && GET_ORDLYD.org_sector"
                  v-model="AlterSectorData.label"
                ></v-text-field>
              </v-flex>
              <v-flex d-flex align-center justify-center>
                <v-btn v-if="AlterSectorData.id" @click="submitEditSector" flat
                  >Oppdater {{ GET_ORDLYD && GET_ORDLYD.org_sector }}</v-btn
                >
                <v-btn v-else @click="submitAddSector" flat
                  >Legg til ny {{ GET_ORDLYD && GET_ORDLYD.org_sector }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAlterArea" width="500">
      <v-card>
        <v-card-title>
          <span class="display-1 font-weight-bold" v-if="AlterAreaData.id"
            >Oppdater {{ GET_ORDLYD && GET_ORDLYD.org_area }}</span
          >
          <span class="display-1 font-weight-bold" v-else
            >Legg til ny {{ GET_ORDLYD && GET_ORDLYD.org_area }}</span
          >
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogAlterArea" flat>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex>
                <v-select
                  :items="customerData.sectors"
                  :label="GET_ORDLYD && GET_ORDLYD.org_sector"
                  item-text="label"
                  item-value="id"
                  v-model="AlterAreaData.sector_id"
                ></v-select>
              </v-flex>
              <v-flex>
                <v-text-field
                  :label="GET_ORDLYD && GET_ORDLYD.org_area"
                  v-model="AlterAreaData.label"
                ></v-text-field>
              </v-flex>

              <v-flex d-flex align-center justify-center>
                <v-btn v-if="AlterAreaData.id" @click="submitEditArea" flat
                  >Oppdater {{ GET_ORDLYD && GET_ORDLYD.org_area }}</v-btn
                >
                <v-btn v-else @click="submitAddArea" flat
                  >Legg til ny {{ GET_ORDLYD && GET_ORDLYD.org_area }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAlterOrdLyd" width="500">
      <v-card>
        <v-card-title>
          <span class="display-1 font-weight-bold" v-if="AlterOrdLydData.id"
            >Oppdater
            {{ GET_ORDLYD && GET_ORDLYD.main_ordlyd.toLowerCase() }}</span
          >
          <span class="display-1 font-weight-bold" v-else
            >Legg til ny
            {{ GET_ORDLYD && GET_ORDLYD.main_ordlyd.toLowerCase() }}</span
          >
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogAlterOrdLyd" flat>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex>
                <v-text-field
                  :label="GET_ORDLYD && GET_ORDLYD.main_ordlyd"
                  v-model="AlterOrdLydData.label"
                ></v-text-field>
              </v-flex>
              <v-flex d-flex align-center justify-center>
                <v-btn v-if="AlterOrdLydData.id" @click="submitEditOrdLyd" flat
                  >Oppdater
                  {{
                    GET_ORDLYD && GET_ORDLYD.main_ordlyd.toLowerCase()
                  }}</v-btn
                >
                <v-btn v-else @click="submitAddOrdLyd" flat
                  >Legg til ny
                  {{
                    GET_ORDLYD && GET_ORDLYD.main_ordlyd.toLowerCase()
                  }}</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAlterPlan" width="500">
      <v-card>
        <v-card-title>
          <span class="display-1 font-weight-bold" v-if="AlterPlanData.id"
            >Oppdater Plan</span
          >
          <span class="display-1 font-weight-bold" v-else
            >Legg til ny Plan</span
          >
          <v-spacer></v-spacer>
          <v-btn @click="cancelDialogAlterPlan" flat>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout column>
              <v-flex>
                <v-text-field
                  label="År"
                  v-model="AlterPlanData.year"
                ></v-text-field>
              </v-flex>
              <v-flex d-flex align-center justify-center>
                <v-btn v-if="AlterPlanData.id" @click="submitEditPlan" flat
                  >Oppdater Plan</v-btn
                >
                <template v-else>
                  <v-flex>
                    <v-select
                      :items="plans"
                      label="Baser på tidligere år"
                      item-text="year"
                      item-value="id"
                      v-model="AlterPlanData.basedonyear"
                    ></v-select>
                  </v-flex>
                  <v-btn @click="submitAddPlan" flat>Legg til ny Plan</v-btn>
                </template>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions([
      "GET_THIS_CUSTOMER",
      "ALTER_CUSTOMER",
      "FETCH_ORDLYD",
      "GET_PLANS",
    ]),
    getPlans() {
      this.GET_PLANS()
        .then((res) => {
          this.plans = res.data.planning;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    getCustomerData() {
      this.GET_THIS_CUSTOMER()
        .then((resp) => {
          this.customerData.customer = resp.data.customers[0];
          this.customerData.organisations = resp.data.organisations;
          this.customerData.users = resp.data.users;
          this.customerData.admin = resp.data.admin;
          this.customerData.resources = resp.data.resources;
          this.customerData.categories = resp.data.categories || [];
          this.customerData.sectors = resp.data.sectors || [];
          this.customerData.areas = resp.data.areas || [];
          this.customerData.ordlyd = resp.data.ordlyd || [];
        })
        .catch((ex) => {
          console.error(ex);
        });
    },
    cancelDialogAlterDepartment() {
      this.resetAlterDepartmentData();
      this.dialogAlterDepartment = false;
    },
    resetAlterDepartmentData() {
      this.AlterDepartmentData.id = null;
      this.AlterDepartmentData.label = "";
      this.AlterDepartmentData.type = "";
      this.AlterDepartmentData.leader = "";
      this.AlterDepartmentData.email = "";
      this.AlterDepartmentData.parentid = null;
      this.AlterDepartmentData.sector_id = null;
      this.AlterDepartmentData.area_id = null;
    },
    editDepartment(id) {
      let currentDep = this.customerData.organisations.find(
        (res) => res.id == id
      );
      if (currentDep) {
        this.AlterDepartmentData.id = currentDep.id;
        this.AlterDepartmentData.label = currentDep.label;
        this.AlterDepartmentData.type = currentDep.type;
        this.AlterDepartmentData.leader = currentDep.leader;
        this.AlterDepartmentData.email = currentDep.email;
        this.AlterDepartmentData.parentid = currentDep.parentid;
        this.AlterDepartmentData.sector_id = currentDep.sector_id;
        this.AlterDepartmentData.area_id = currentDep.area_id;
        this.dialogAlterDepartment = true;
      }
    },
    submitEditDepartment() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "editdepartment",
        data: this.AlterDepartmentData,
      }).finally(() => {
        this.dialogAlterDepartment = false;
        this.resetAlterDepartmentData();
        this.getCustomerData();
      });
    },
    submitAddDepartment() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "createdepartment",
        data: this.AlterDepartmentData,
      }).finally(() => {
        this.dialogAlterDepartment = false;
        this.resetAlterDepartmentData();
        this.getCustomerData();
      });
    },
    deleteDepartment(departmentid) {
      var confirmed = confirm(
        "Er du helt sikker på at du ønsker å slette denne avdelinga?"
      );
      if (confirmed) {
        this.ALTER_CUSTOMER({
          customerid: this.GET_USER.customerid,
          Transfer: "deletedepartment",
          data: departmentid,
        }).finally(() => {
          this.getCustomerData();
        });
      }
    },

    /////
    cancelDialogAlterPlan() {
      this.resetAlterPlanData();
      this.dialogAlterPlan = false;
    },
    resetAlterPlanData() {
      this.AlterPlanData.id = null;
      this.AlterPlanData.year = "";
      this.AlterPlanData.title = "";
      this.AlterPlanData.deleted = false;
    },
    editPlan(id) {
      let currentPlan = this.plans.find((res) => res.id == id);
      if (currentPlan) {
        this.AlterPlanData.id = currentPlan.id;
        this.AlterPlanData.year = currentPlan.year;
        this.AlterPlanData.title = currentPlan.title;
        this.AlterPlanData.deleted = currentPlan.deleted;
        this.dialogAlterPlan = true;
      }
    },
    submitEditPlan() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "editplan",
        data: this.AlterPlanData,
      }).finally(() => {
        this.dialogAlterPlan = false;
        this.resetAlterPlanData();
        // this.getCustomerData();
        this.getPlans();
      });
    },
    submitAddPlan() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "createplan",
        data: this.AlterPlanData,
      }).finally(() => {
        this.dialogAlterPlan = false;
        this.resetAlterPlanData();
        this.getPlans();
      });
    },
    setActivePlan(Planid) {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "activateplan",
        data: Planid,
      }).finally(() => {
        this.getPlans();
      });
    },
    deletePlan(Planid) {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "deleteplan",
        data: { deleted: 1, id: Planid },
      }).finally(() => {
        this.getPlans();
      });
    },
    undeletePlan(Planid) {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "deleteplan",
        data: { deleted: 0, id: Planid },
      }).finally(() => {
        this.getPlans();
      });
    },
    /////
    cancelDialogAlterUser() {
      this.resetAlterUserData();
      this.dialogAlterUser = false;
    },
    resetAlterUserData() {
      this.AlterUserData.id = null;
      this.AlterUserData.name = "";
      this.AlterUserData.email = "";
      this.AlterUserData.password = "";
      this.AlterUserData.role = "";
      this.AlterUserData.organisation = null;
    },
    editUser(id) {
      let currentUser = this.customerData.users.find((res) => res.id == id);
      if (currentUser) {
        this.AlterUserData.id = currentUser.id;
        this.AlterUserData.name = currentUser.name;
        this.AlterUserData.email = currentUser.username;
        this.AlterUserData.role = currentUser.role;
        this.AlterUserData.organisation = currentUser.orgId;
        this.dialogAlterUser = true;
      }
    },
    submitEditUser() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "edituser",
        data: this.AlterUserData,
      })
        .then((resp) => {
          this.dialogAlterUser = false;
          this.resetAlterUserData();
          this.getCustomerData();
        })
        .catch((err) => {
          alert("Kunne ikke endre bruker");
        });
    },
    submitAddUser() {
      this.AlterUserData.email = this.AlterUserData.email.toLowerCase();
      this.AlterUserData.password = this.AlterUserData.password.toLowerCase();
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "createuser",
        data: this.AlterUserData,
      })
        .then((resp) => {
          this.dialogAlterUser = false;
          this.resetAlterUserData();
        })
        .catch((err) => {
          alert("Kunne ikke opprette bruker");
        })
        .finally(() => {
          this.getCustomerData();
        });
    },
    deleteUser(userid) {
      var confirmed = confirm(
        "Er du helt sikker på at du ønsker å slette denne brukeren?"
      );
      if (confirmed) {
        this.ALTER_CUSTOMER({
          customerid: this.GET_USER.customerid,
          Transfer: "deleteuser",
          data: userid,
        }).finally(() => {
          this.getCustomerData();
        });
      }
    },
    cancelDialogAlterResource() {
      this.resetAlterResourceData();
      this.dialogAlterResource = false;
    },
    resetAlterResourceData() {
      this.AlterResourceData.id = null;
      this.AlterResourceData.abbreviation = "";
      this.AlterResourceData.description = "";
      this.AlterResourceData.contact = "";
      this.AlterResourceData.email = "";
      this.AlterResourceData.phone = "";
    },
    editResource(id) {
      let _current = this.customerData.resources.find((res) => res.id == id);
      if (_current) {
        this.AlterResourceData.id = _current.id;
        this.AlterResourceData.abbreviation = _current.abbreviation;
        this.AlterResourceData.description = _current.description;
        this.AlterResourceData.contact = _current.contact;
        this.AlterResourceData.email = _current.email;
        this.AlterResourceData.phone = _current.phone;
        this.dialogAlterResource = true;
      }
    },
    submitEditResource() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "editresource",
        data: this.AlterResourceData,
      }).finally(() => {
        this.dialogAlterResource = false;
        this.resetAlterResourceData();
        this.getCustomerData();
      });
    },
    submitAddResource() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "createresource",
        data: this.AlterResourceData,
      }).finally(() => {
        this.dialogAlterResource = false;
        this.resetAlterResourceData();
        this.getCustomerData();
      });
    },
    deleteResource(resourceid) {
      var confirmed = confirm(
        "Er du helt sikker på at du ønsker å slette denne ressursen?"
      );
      if (confirmed) {
        this.ALTER_CUSTOMER({
          customerid: this.GET_USER.customerid,
          Transfer: "deleteresource",
          data: resourceid,
        }).finally(() => {
          this.getCustomerData();
        });
      }
    },
    //// kategori
    cancelDialogAlterCategory() {
      this.resetAlterCategoryData();
      this.dialogAlterCategory = false;
    },
    resetAlterCategoryData() {
      this.AlterCategoryData.id = null;
      this.AlterCategoryData.category = "";
    },
    editCategory(id) {
      let _current = this.customerData.categories.find((res) => res.id == id);
      if (_current) {
        this.AlterCategoryData.id = _current.id;
        this.AlterCategoryData.category = _current.category;
        this.dialogAlterCategory = true;
      }
    },
    submitEditCategory() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "editcategory",
        data: this.AlterCategoryData,
      }).finally(() => {
        this.dialogAlterCategory = false;
        this.resetAlterCategoryData();
        this.getCustomerData();
      });
    },
    submitAddCategory() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "createcategory",
        data: this.AlterCategoryData,
      }).finally(() => {
        this.dialogAlterCategory = false;
        this.resetAlterCategoryData();
        this.getCustomerData();
      });
    },
    deleteCategory(id) {
      var confirmed = confirm(
        "Er du helt sikker på at du ønsker å slette denne kategorien?"
      );
      if (confirmed) {
        this.ALTER_CUSTOMER({
          customerid: this.GET_USER.customerid,
          Transfer: "deletecategory",
          data: id,
        }).finally(() => {
          this.getCustomerData();
        });
      }
    },
    //// sektor
    cancelDialogAlterSector() {
      this.resetAlterSectorData();
      this.dialogAlterSector = false;
    },
    resetAlterSectorData() {
      this.AlterSectorData.id = null;
      this.AlterSectorData.label = "";
    },
    editSector(id) {
      let _current = this.customerData.sectors.find((res) => res.id == id);
      if (_current) {
        this.AlterSectorData.id = _current.id;
        this.AlterSectorData.label = _current.label;
        this.dialogAlterSector = true;
      }
    },
    submitEditSector() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "editsector",
        data: this.AlterSectorData,
      }).finally(() => {
        this.dialogAlterSector = false;
        this.resetAlterSectorData();
        this.getCustomerData();
      });
    },
    submitAddSector() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "createsector",
        data: this.AlterSectorData,
      }).finally(() => {
        this.dialogAlterSector = false;
        this.resetAlterSectorData();
        this.getCustomerData();
      });
    },
    deleteSector(id) {
      var confirmed = confirm(
        "Er du helt sikker på at du ønsker å slette denne kategorien?"
      );
      if (confirmed) {
        this.ALTER_CUSTOMER({
          customerid: this.GET_USER.customerid,
          Transfer: "deletesector",
          data: id,
        }).finally(() => {
          this.getCustomerData();
        });
      }
    },
    //// virksomhet
    cancelDialogAlterArea() {
      this.resetAlterAreaData();
      this.dialogAlterArea = false;
    },
    resetAlterAreaData() {
      this.AlterAreaData.id = null;
      this.AlterAreaData.sector_id = null;
      this.AlterAreaData.label = "";
    },
    editArea(id) {
      let _current = this.customerData.areas.find((res) => res.id == id);
      if (_current) {
        this.AlterAreaData.id = _current.id;
        this.AlterAreaData.sector_id = _current.sector_id;
        this.AlterAreaData.label = _current.label;
        this.dialogAlterArea = true;
      }
    },
    submitEditArea() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "editarea",
        data: this.AlterAreaData,
      }).finally(() => {
        this.dialogAlterArea = false;
        this.resetAlterAreaData();
        this.getCustomerData();
      });
    },
    submitAddArea() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "createarea",
        data: this.AlterAreaData,
      }).finally(() => {
        this.dialogAlterArea = false;
        this.resetAlterAreaData();
        this.getCustomerData();
      });
    },
    deleteArea(id) {
      var confirmed = confirm(
        "Er du helt sikker på at du ønsker å slette denne kategorien?"
      );
      if (confirmed) {
        this.ALTER_CUSTOMER({
          customerid: this.GET_USER.customerid,
          Transfer: "deletearea",
          data: id,
        }).finally(() => {
          this.getCustomerData();
        });
      }
    },
    cancelDialogAlterOrdLyd() {
      this.resetAlterOrdLydData();
      this.dialogAlterOrdLyd = false;
    },
    resetAlterOrdLydData() {
      this.AlterOrdLydData.ordlydtabell_id = null;
      this.AlterOrdLydData.id = null;
      this.AlterOrdLydData.label = "";
    },
    editOrdLyd(id) {
      let _current = this.customerData.ordlyd.find(
        (res) => res.ordlyd_customer_id == id
      );
      if (_current) {
        this.AlterOrdLydData.ordlydtabell_id = _current.id;
        this.AlterOrdLydData.id = _current.ordlyd_customer_id;
        this.AlterOrdLydData.label = _current.label;
        this.dialogAlterOrdLyd = true;
      }
    },
    submitEditOrdLyd() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "editordlyd",
        data: this.AlterOrdLydData,
      }).finally(() => {
        this.dialogAlterOrdLyd = false;
        this.resetAlterOrdLydData();
        this.getCustomerData();
        this.FETCH_ORDLYD();
      });
    },
    submitAddOrdLyd() {
      this.ALTER_CUSTOMER({
        customerid: this.GET_USER.customerid,
        Transfer: "createordlyd",
        data: this.AlterOrdLydData,
      }).finally(() => {
        this.dialogAlterOrdLyd = false;
        this.resetAlterOrdLydData();
        this.getCustomerData();
      });
    },
    deleteOrdLyd(id) {
      var confirmed = confirm(
        "Er du helt sikker på at du ønsker å slette denne ordlyden?"
      );
      if (confirmed) {
        this.ALTER_CUSTOMER({
          customerid: this.GET_USER.customerid,
          Transfer: "deleteordlyd",
          data: id,
        }).finally(() => {
          this.getCustomerData();
        });
      }
    },
  },
  watch: {
    dialogAlterPlan(val) {
      if (!val) {
        this.resetAlterPlanData();
      }
    },
    dialogAlterDepartment(val) {
      if (!val) {
        this.resetAlterDepartmentData();
      }
    },
    dialogAlterUser(val) {
      if (!val) {
        this.resetAlterUserData();
      }
    },
    dialogAlterResource(val) {
      if (!val) {
        this.resetAlterResourceData();
      }
    },
    dialogAlterCategory(val) {
      if (!val) {
        this.resetAlterCategoryData();
      }
    },
    dialogAlterSector(val) {
      if (!val) {
        this.resetAlterSectorData();
      }
    },
    dialogAlterArea(val) {
      if (!val) {
        this.resetAlterAreaData();
      }
    },
    dialogAlterOrdLyd(val) {
      if (!val) {
        this.resetAlterOrdLydData();
      }
    },
  },
  data() {
    return {
      showpassword: true,
      showPassword: false,
      dialogAlterDepartment: false,
      dialogAlterUser: false,
      dialogAlterResource: false,
      dialogAlterCategory: false,
      dialogAlterSector: false,
      dialogAlterArea: false,
      dialogAlterOrdLyd: false,
      dialogAlterPlan: false,
      search: "",

      userRoles: [
        { text: "Hovedadministrator", value: "admin" },
        { text: "Avdelingsadministrator", value: "user" },
        // { text: "Kun lesetilgang", value: "public" }
      ],
      UserHeaders: [
        { text: "Navn", value: "name"},
        { text: "E-Post", value: "username" },
        // { text: "E-Post", value: "email", },
        { text: "Avdeling", value: "orgLabel" },
        { text: "Tilgang", value: "role" },
      ],

      OrgHeaders: [
        // { text: "Avd.Id", value: "id", sortable: true },
        { text: "Leder", value: "leader" },
        { text: "E-Post", value: "email" },
        { text: "Sektor", value: "sector_label", sortable: true },
        { text: "Virksomhet", value: "area_label", sortable: true },
        { text: "Navn", value: "label", sortable: true },
      ],
      OrdLydHeaders: [
        // { text: "Avd.Id", value: "id", sortable: true },
        { text: "Ord", value: "label", sortable: true },
      ],
      PlanHeaders: [
        { text: "År", value: "year", sortable: true },
        { text: "Tittel", value: "title", sortable: true },
      ],

      AlterDepartmentData: {
        id: null,
        label: "",
        parentid: null,
        leader: "",
        email: "",
        type: "",
        sector_id: null,
        area_id: null,
      },
      AlterUserData: {
        id: null,
        name: "",
        email: "",
        password: "",
        role: "",
        organisation: null,
      },
      AlterResourceData: {
        id: null,
        abbreviation: "",
        description: "",
        contact: "",
        email: "",
        phone: "",
      },
      AlterCategoryData: {
        id: null,
        category: "",
      },
      AlterSectorData: {
        id: null,
        label: "",
      },
      AlterAreaData: {
        id: null,
        label: "",
        sector_id: null,
      },
      customerData: {
        customer: {
          id: null,
          adminid: null,
          label: "",
        },
        organisations: [],
        users: [],
        admin: null,
        categories: [],
      },
      AlterOrdLydData: {
        id: null,
        label: "",
        ordlyd_customer_id: "",
      },
      AlterPlanData: {
        id: null,
        title: "",
        year: "",
        deleted: false,
        basedonyear: null,
      },
      plans: [],
    };
  },
  computed: {
    ...mapGetters(["GET_USER", "GET_ORDLYD"]),
    user() {
      return this.$store.getters.GET_USER;
    },
    // orgWithDepth() {
    //   let _organisations = this.customerData.organisations;
    //   let _sectors = this.customerData.sectors;
    //   let _areas = this.customerData.areas;
    //   let _Return = [];
    //   _organisations.forEach(org => {
    //     let _newLabel = [];
    //     if (org.sector_id) {
    //       let _currentsector = _sectors.find(
    //         sector => sector.id == org.sector_id
    //       );
    //       _newLabel.push(_currentsector.label);
    //     }

    //     if (org.area_id) {
    //       let _currentarea = _areas.find(area => area.id == org.area_id);
    //       _newLabel.push(_currentarea.label);
    //     }
    //     _newLabel.push(org.label);
    //     _Return.push({
    //       id: org.id,
    //       label: _newLabel.join(" / ")
    //     });
    //   });
    //   return _Return.sort((a, b) =>
    //     a.label < b.label ? -1 : a.label > b.label ? 1 : 0
    //   );
    // },
    selectedSectorAreas() {
      return this.customerData.areas.filter(
        (area) => area.sector_id == this.AlterDepartmentData.sector_id
      );
    },
  },

  mounted() {
    this.getCustomerData();
    this.getPlans();
  },
};
</script>
